module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_benabid_sm-303828585a0c2be28593bcdd920706e4.png";